import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import App from "./app/index";
import Modals from "./modals.js";

export default new Vuex.Store({
  strict: true,
  modules: {
    App,
    Modals,
  },
});
